import { createSelector } from '@ngrx/store';
import { getCarCategoriesFeatureState } from '@shared/store/travel-search/selectors/car-hire-categories.selectors';
import * as fromReducers from '../reducers';
import * as fromCarHireSearch from '../reducers/car-hire-search.reducers';
import { CarHireSearchInitialState } from '../reducers/car-hire-search.reducers';

export const getCarHireSearchFeatureState = createSelector(
  fromReducers.getTravelSearchState,
  (state: fromReducers.TravelSearchState) => state.carHireSearch
);

export const getCarHireSearchData = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getSearchData);
export const getCarSearchResultsRetrieved = createSelector(
  getCarHireSearchFeatureState,
  fromCarHireSearch.getCarSearchResultsLoaded
);
export const getCarSearchResultsLoading = createSelector(
  getCarHireSearchFeatureState,
  fromCarHireSearch.getCarSearchResultsLoading
);
export const getCarSearchResultsData = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getResults);
export const getCarSearchVisible = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getVisibleCars);
export const getCarSupplierNames = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getSupplierNames);
export const getCarCategoryTypes = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getCarTypes);
export const getCarPaxCapacities = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getPaxCapacities);
export const getCarSearchTotalPages = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getTotalPages);
export const getSelectedCar = createSelector(getCarHireSearchFeatureState, fromCarHireSearch.getSelectedCar);

export const getSelectableCarFilterValues = createSelector(
  getCarCategoriesFeatureState,
  getCarSupplierNames,
  getCarPaxCapacities,
  (types, suppliers, capacities) => {
    return {
      car_type: types,
      supplier: suppliers.map((supplier) => ({ id: supplier, name: supplier })),
      pax_capacity: capacities.map((capacity) => ({ id: capacity, name: capacity.toString() })),
    };
  }
);

export const getCarSubBookingData = createSelector(getCarHireSearchFeatureState, (state: CarHireSearchInitialState) => {
  if (!state.selectedCar || !state.selectedCar.booking_token) {
    return {};
  }

  return {
    search_reference_id: state.carSearchResults.search_reference_id,
    search_result_booking_token: state.selectedCar.booking_token,
    start_location_id: parseInt(state.selectedCar.start_location.tp_depot_id, 10),
    start_location_city: state.selectedCar.start_location.city,
    start_location_name: state.selectedCar.start_location.depot_name,
    end_location_id: parseInt(state.selectedCar.end_location.tp_depot_id, 10),
    end_location_city: state.selectedCar.end_location.city,
    end_location_name: state.selectedCar.end_location.depot_name,
    transmission: state.selectedCar.transmission.type,
    type: state.selectedCar.car_category_ids,
    supplier: state.selectedCar.supplier_name,
    start_datetime: state.selectedCar.start_date_full,
    end_datetime: state.selectedCar.end_date_full,
  };
});
